import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { createQueriedURL, routeReplacer } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { Customer } from '~/Models/DTO/Customer.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { Provider } from '~/Models/DTO/Provider.model';

const requestCustomerList = async (
  defaultQuery: { [name: string]: any },
  currentProvider: Provider | null,
) => {
  let responseHeaders: Headers | null = null;
  const data = await requestReactQuery<Customer[]>({
    url: createQueriedURL(
      routeReplacer(CORE_SERVICE_URLS.CUSTOMER_LIST, {
        domain: currentProvider?.domain || '',
      }),
      defaultQuery,
    ),
    config: { method: 'GET' },
    retrieveResponseHeader: (headers) => (responseHeaders = headers),
  });
  return { data, responseHeaders };
};
export const useRequestCustomerList = (defaultQuery: { [name: string]: any }) => {
  const { currentProvider } = useProvider();
  const result = useQuery<any, IErrorResponse>(
    [REQUEST_ACTIONS.CUSTOMER_LIST_RAW, defaultQuery],
    () => requestCustomerList(defaultQuery, currentProvider),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: TIME_VALUES.HOUR,
    },
  );
  return { ...result, data: result.data?.data, responseHeaders: result.data?.responseHeaders };
};

export interface IGetProductCustomerListProp {
  customerId: string;
  eventId: string;
}

export const useRequestEventProductsForCustomer = (request: IGetProductCustomerListProp) =>
  useQuery<any[], IErrorResponse>(
    [REQUEST_ACTIONS.CUSTOMER_LIST, request],
    () =>
      requestReactQuery<any[]>({
        url: routeReplacer(CORE_SERVICE_URLS.CUSTOMER_EVENT_ORDERLINES, {
          customerId: request.customerId,
          eventId: request.eventId,
        }),
        config: { method: 'GET' },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: TIME_VALUES.HOUR,
    },
  );
